export const vocSearchType = [
  {
    value: "ALL",
    label: "전체",
  },
  {
    value: "ID",
    label: "VoC 항목 ID",
  },
  {
    value: "NAME",
    label: "항목명",
  },
];

export const vocTabs = [
  { value: "basicInfo", label: "기본정보" },
  { value: "alarmSetting", label: "알림 설정" },
  { value: "history", label: "변경내역" },
];

export const CsNotificationChannels = {
  KAKAO_TALK: "알림톡",
  EMAIL: "이메일",
};
